import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

const GET_PAYABLE_CONTRACTS = 'GET_PAYABLE_CONTRACTS';
export const GET_PAYABLE_CONTRACTS_API = buildApiTypeAction(GET_PAYABLE_CONTRACTS, ApiActionTypes.REQUEST)
export const GET_PAYABLE_CONTRACTS_API_SUCCESS = buildApiTypeAction(GET_PAYABLE_CONTRACTS, ApiActionTypes.SUCCESS)
export const GET_PAYABLE_CONTRACTS_API_ERROR = buildApiTypeAction(GET_PAYABLE_CONTRACTS, ApiActionTypes.ERROR)

const CREATE_PAYABLE_CONTRACT = 'CREATE_PAYABLE_CONTRACT';
export const CREATE_PAYABLE_CONTRACT_API = buildApiTypeAction(CREATE_PAYABLE_CONTRACT, ApiActionTypes.REQUEST)
export const CREATE_PAYABLE_CONTRACT_API_SUCCESS = buildApiTypeAction(CREATE_PAYABLE_CONTRACT, ApiActionTypes.SUCCESS)
export const CREATE_PAYABLE_CONTRACT_API_ERROR = buildApiTypeAction(CREATE_PAYABLE_CONTRACT, ApiActionTypes.ERROR)

const GET_PAYABLE_CONTRACT_BY_ID = 'GET_PAYABLE_CONTRACT_BY_ID';
export const GET_PAYABLE_CONTRACT_BY_ID_API = buildApiTypeAction(GET_PAYABLE_CONTRACT_BY_ID, ApiActionTypes.REQUEST)
export const GET_PAYABLE_CONTRACT_BY_ID_API_SUCCESS = buildApiTypeAction(GET_PAYABLE_CONTRACT_BY_ID, ApiActionTypes.SUCCESS)
export const GET_PAYABLE_CONTRACT_BY_ID_API_ERROR = buildApiTypeAction(GET_PAYABLE_CONTRACT_BY_ID, ApiActionTypes.ERROR)

export const CLEAN_CURRENT_PAYABLE_CONTRACT = 'CLEAN_CURRENT_PAYABLE_CONTRACT';

const UPDATE_PAYABLE_CONTRACT = 'UPDATE_PAYABLE_CONTRACT';
export const UPDATE_PAYABLE_CONTRACT_API = buildApiTypeAction(UPDATE_PAYABLE_CONTRACT, ApiActionTypes.REQUEST)
export const UPDATE_PAYABLE_CONTRACT_API_SUCCESS = buildApiTypeAction(UPDATE_PAYABLE_CONTRACT, ApiActionTypes.SUCCESS)
export const UPDATE_PAYABLE_CONTRACT_API_ERROR = buildApiTypeAction(UPDATE_PAYABLE_CONTRACT, ApiActionTypes.ERROR)